import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import Intro from './views/intro'
import { Auth, Dashboard } from './membership'
import NotFound from './views/not-found'
import { GiftCardInfo, VipCardInfo } from './views/card-info'
import ScrollToTop from './components/ScrollToTop'

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/intro" element={<Intro />} />
        {/* Per-store Get Started posters (WEB-Q11 Design B): same page,
            the path names the store for acquisition tracking */}
        <Route path="/bellevue" element={<Intro store="bellevue" />} />
        <Route path="/kent" element={<Intro store="kent" />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/404" element={<NotFound />} />
        {/* Permanently reserved physical-card QR routes (see README).
            Must render for every token with no lookup, no 404, no redirect. */}
        <Route path="/c/*" element={<GiftCardInfo />} />
        <Route path="/vip/*" element={<VipCardInfo />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
      <ScrollToTop />
    </Router>
  )
}

// React 18 root API (the legacy ReactDOM.render forced React 17
// compatibility mode and logged a deprecation warning)
createRoot(document.getElementById('app')).render(<App />)
